import styled from 'styled-components';
import PropTypes from 'prop-types';
import { LoadingIndicator } from '@cfa/react-components';

const Overlay = (props) => {
  const { className } = props;
  return (
    <StyledOverlay role="presentation" className={className}>
      <LoadingIndicator variant="page" size="lg" className="loading" />
    </StyledOverlay>
  );
};

const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(90, 90, 90, 0.75);
  z-index: 800;

  .loading {
    margin: 40vh auto !important;
  }
`;

Overlay.propTypes = {
  className: PropTypes.string,
};

Overlay.defaultProps = {
  className: '',
};

export default Overlay;
